import {colorCorrectMetallic, colorCorrectNonMetallic} from '../src/utils';
import Color from "color";

async function generate(ev) {
    let outEl = document.getElementById('output');
    // All very dirty!
    const bike = document.getElementById('bike').value;
    const design = document.getElementById('design').value;
    const colorCount = 5;
    let colorIds = [];
    for (let i = 0; i < colorCount; ++i) colorIds.push(`color-${i + 1}`)
    let colors = colorIds.map(id => ({
        id,
        value: document.getElementById(id).value,
        metallic: document.getElementById(`${id}-metallic`).checked
    }));
    const includeUSDZ = document.getElementById('include-usdz').checked;
    
    let url = new URL(`/api/customize/${bike}/${design}/`, window.location.href);
    for (let color of colors) {
        url.searchParams.set(color.id, color.value);
        if (color.metallic) {
            url.searchParams.set(`${color.id}-metallic`, true);
        }
    }
    if (includeUSDZ) {
        url.searchParams.set("format", "gltf,usdz");
    } else {
        url.searchParams.set("format", "gltf");
    }
    
    let paintFinish = document.getElementById('finish').value;
    url.searchParams.set('finish', paintFinish);
    
    // Indicate working
    outEl.innerHTML = '! GENERATING, PLEASE WAIT ~10secs !';
    outEl.classList.add('generating');
    outEl.classList.remove('result-success');
    outEl.classList.remove('result-error');
    
    try {
        let response = await fetch(url.href);
        if (response.status >= 200 && response.status < 300) {
            let result = await response.json();
            
            let gltf = new URL(result.gltf, window.location);
            let usdz = new URL(result.usdz, window.location);
            
            /** @type {HTMLTemplateElement} */
            let template = document.createElement('template');
            let timings = [];
            for (let key in result.timings) {
                let ms = result.timings[ key ];
                timings.push(`<span class="timing">
                    <span class="task">${key}</span>
                    <span class="duration">
                        ${Math.floor(ms / 1000)}s&nbsp;
                        ${("000" + (ms % 1000).toString()).slice(-3)}ms
                    </span>
                </span>`);
            }
            template.innerHTML = `
                <div class="results">
                    <a href="${gltf.href}">Windows</a>
                    <a href="intent://arvr.google.com/scene-viewer/1.0?file=${gltf.href}#Intent;scheme=https;package=com.google.android.googlequicksearchbox;action=android.intent.action.VIEW;S.browser_fallback_url=https://developers.google.com/ar;end;">Android</a>
                    ${usdz.href ? `<a href="${usdz.href}">iOS</a>` : ''}
                </div>
                <div class="timings">
                    ${timings.join('\n')}
                </div>
        `;
            
            outEl.innerHTML = '';
            outEl.appendChild(template.content.cloneNode(true));
            
            outEl.classList.add('result-success');
            outEl.classList.remove('generating');
            outEl.classList.remove('result-error');
        } else {
            outEl.innerText = `${response.status} - ${response.statusText}`;
            outEl.classList.remove('result-success');
            outEl.classList.remove('generating');
            outEl.classList.add('result-error');
        }
    } catch (err) {
        outEl.innerText = `${err.toString()}`;
        outEl.classList.remove('result-success');
        outEl.classList.remove('generating');
        outEl.classList.add('result-error');
    }
}

window.bcfCustomize = generate;

// Init
const bikes = [
    {
        id: 'noah fast', name: "Noah Fast", designs: [
            { id: "noah fast classic", name: "Classic" },
            { id: "noah fast fade", name: "Fade" },
            { id: "noah fast heritage", name: "Heritage" },
            { id: "noah fast team", name: "Team" },
            { id: "noah fast pureline x", name: "Pureline X" },
            { id: "noah fast pureline xl", name: "Pureline XL" },
            { id: "noah fast purest", name: "Purest" },
            { id: "noah fast level 20", name: "Level 20" },
            { id: "noah fast level 21", name: "Level 21" },
            { id: "noah fast lotto soudal replica", name: "Lotto Soudal" },
        ]
    },
    {
        id: 'fenix', name: "Fenix SL", designs: [
            { id: "fenix classic", name: "Classic" },
            { id: "fenix fade", name: "Fade" },
            { id: "fenix heritage", name: "Heritage" },
            { id: "fenix team", name: "Team" },
            { id: "fenix pureline xl", name: "Pureline XL" },
            { id: "fenix purest", name: "Purest" },
            { id: "fenix fsd30", name: "FSD30" },
        ]
    },
    {
        id: 'fenix sl', name: "Fenix SL", designs: [
            { id: "fenix sl classic", name: "Classic" },
            { id: "fenix sl pureline xl", name: "Pureline XL" },
            { id: "fenix sl fsd08", name: "FSD08" },
        ]
    },
    {
        id: 'helium slx', name: "Helium SLX", designs: [
            { id: "helium slx heritage", name: "Heritage" },
        ]
    },
    {
        id: 'old x-ride', name: "X-Ride (old)", designs: [
            { id: "x-ride xl", name: "X-Ride XL" },
        ]
    },
    {
        id: 'old x-night', name: "X-Night (old)", designs: [
            { id: "x-night xl", name: "X-Night XL" },
        ]
    },
    {
        id: 'old kanzo-c', name: "Kanzo-C (old)", designs: [
            { id: "kanzo-c xl", name: "Kanzo-C XL" },
        ]
    },
    {
        id: 'old kanzo-a-alu', name: "Kanzo-A ALU (old)", designs: [
            { id: "kanzo-a kaa02", name: "Kanzo-A KAA02" },
        ]
    },
    {
        id: 'kanzo fast', name: "Kanzo Fast", designs: [
            { id: "kanzo fast classic", name: "Kanzo Fast Classic" },
            { id: "kanzo fast fade", name: "Kanzo Fast Fade" },
            { id: "kanzo fast heritage", name: "Kanzo Fast Heritage" },
            { id: "kanzo fast team", name: "Kanzo Fast Team" },
            { id: "kanzo fast purest", name: "Kanzo Fast Purest" },
            { id: "kanzo fast xl", name: "Kanzo Fast XL" },
            { id: "kanzo fast kaf01", name: "Kanzo Fast KAF01" },
            { id: "kanzo fast kaf01bs", name: "Kanzo Fast KAF01Bs" },
        ]
    },
    {
        id: 'kanzo speed', name: "Kanzo Speed", designs: [
            { id: "kanzo speed classic", name: "Kanzo Speed Classic" },
            { id: "kanzo speed xl", name: "Kanzo Speed XL" },
            { id: "kanzo speed 01", name: "Kanzo Speed 01" },
            { id: "kanzo speed 01As", name: "Kanzo Speed 01As" },
            { id: "kanzo speed 01Bs", name: "Kanzo Speed 01Bs" },
        ]
    }
];

function onBikeChange() {
    let bikeId = document.getElementById('bike').value;
    let bike = bikes.find(b => b.id === bikeId) ?? bikes[ 0 ];
    let designSelect = document.getElementById('design');
    designSelect.innerHTML = bike.designs.map(d => `<option value="${d.id}">${d.name}</option>`).join('');
    console.log({ bikeId, bike, designSelect });
}

function loadBikeOptions() {
    let bikeSelect = document.getElementById('bike');
    bikeSelect.innerHTML = bikes.map(d => `<option value="${d.id}">${d.name}</option>`).join('');
    bikeSelect.value = bikes[ 0 ].id;
    console.log({ bikeSelect });
}

const colorDefaults = [
    '#0e050f',// PROBLEM CHILD!
    '#A80000',
    '#E9B701',
    
    '#D6D6D6',
    '#3090f0'
]

function addColorsHtml() {
    const colorInputDiv = document.getElementById('color-input-controls');
    const colorPreviewDiv = document.getElementById('color-previews');
    for (let i = 0; i < 5; ++i) {
        let colorI = i + 1;
        let id = `color-${colorI}`;
        const hexValue = colorDefaults[ i ]
        
        // Input
        /** @type {HTMLTemplateElement} */
        const templ = document.createElement('template');
        templ.innerHTML = `<div class="color-control">
            <input id="${id}" type="color" value="${hexValue}"/>

            <label class="switch">
                <input type="checkbox" id="${id}-metallic">
                <span class="slider round"></span>
            </label>
        </div>`;
        colorInputDiv.appendChild(templ.content.cloneNode(true));
        let colorInput = document.getElementById(id);
        let metallicSwitch = document.getElementById(`${id}-metallic`);
        
        // preview
        /** @type {HTMLTemplateElement} */
        const templPrev = document.createElement('template');
        templPrev.innerHTML = `<div class="color-preview">
            <div id="${id}-preview-info" class="color-preview-info"></div>
            <div id="${id}-preview" class="color-preview-box" style="background-color: ${hexValue};"/>
        </div>`;
        colorPreviewDiv.appendChild(templPrev.content.cloneNode(true));
        let colorPreview = document.getElementById(`${id}-preview`);
        let colorPreviewInfo = document.getElementById(`${id}-preview-info`);
        
        // TODO preview normalizations
        
        let updatePreview = (ev) => previewColor({
            id,
            input: colorInput,
            metallic: metallicSwitch,
            preview: colorPreview,
            previewInfo: colorPreviewInfo,
        });
        updatePreview();
        
        colorInput.addEventListener('input', updatePreview);
        metallicSwitch.addEventListener('input', updatePreview);
    }
}

function previewColor({ id, input, metallic, preview, previewInfo }) {
    let hex = input.value;
    let isMetallic = metallic.checked;
    let corrected = isMetallic? colorCorrectMetallic(hex) : colorCorrectNonMetallic(hex);
    
    let hslIn = Color(hex).hsl();
    let hslOut = Color(corrected).hsl();
    
    previewInfo.innerHTML = `
        S:${Math.round(hslIn.color[1])} L:${Math.round(hslIn.color[2])}</br>
        S:${Math.round(hslOut.color[1])} L:${Math.round(hslOut.color[2])}
    `
    preview.style.backgroundColor = corrected;
}

function bindEvents() {
    let bikeselector = document.getElementById('bike');
    bikeselector.addEventListener('change', () => onBikeChange());
    bikeselector.addEventListener('input', () => onBikeChange());
    
    let generateBtn = document.getElementById('generate');
    generateBtn.addEventListener('click', () => generate());
    
    addColorsHtml();
    onBikeChange();
}


loadBikeOptions();
bindEvents();
